import axios from 'axios';

import { somethingWrongNotification } from '../redux/notifier/notifierActions';
import store from '../store';

/**
 * Sends an API request using the provided callApi function and handles its response.
 *
 * @async
 * @param {Function} callApi - The function responsible for making the API call.
 * @param {Object} [options] - Options for customizing request handling.
 * @param {number} [options.successStatusCode=200] - The expected success status code.
 * @param {Function} [options.onError] - Custom error handling function.
 * @returns {Promise<Response>} The response from the API call.
 * @throws {Error} If the API call does not return the expected success status code.
 * @throws {Error} If an error occurs during the API call or response handling.
 *
 */
const sendRequest = async (callApi, options = COMMON_REQUEST_OPTIONS) => {
  const {
    successStatusCode = COMMON_REQUEST_OPTIONS.successStatusCode,
    onError = COMMON_REQUEST_OPTIONS.onError,
    onSuccess,
  } = options;

  try {
    const source = axios.CancelToken.source();

    const response = await callApi(source.token);

    if (response.status === successStatusCode) {
      if (onSuccess) {
        onSuccess(response);
      }

      return response;
    } else {
      throw new Error();
    }
  } catch (error) {
    console.error(error);
    onError(error);

    throw error;
  }
};

export const COMMON_REQUEST_OPTIONS = {
  successStatusCode: 200,
  onError: () => {
    store.dispatch(somethingWrongNotification());
  },
  onSuccess: () => null,
};

export default sendRequest;
